import { CSSProperties, useEffect, useState } from 'react'

const COMPACT_CARDS_QUERY = '(max-width: 1130px)'

function getPaintingCardsPerPage() {
  if (typeof window === 'undefined') return 3

  return window.matchMedia(COMPACT_CARDS_QUERY).matches ? 2 : 3
}

export function usePaintingCardsPerPage() {
  const [cardsPerPage, setCardsPerPage] = useState(getPaintingCardsPerPage)

  useEffect(() => {
    const mediaQuery = window.matchMedia(COMPACT_CARDS_QUERY)
    const handleChange = () => setCardsPerPage(mediaQuery.matches ? 2 : 3)

    handleChange()
    mediaQuery.addEventListener('change', handleChange)

    return () => {
      mediaQuery.removeEventListener('change', handleChange)
    }
  }, [])

  return cardsPerPage
}

export function getPaintingCardTrackStyle(startIndex: number): CSSProperties {
  return {
    transform: `translateX(calc(var(--painting-card-container-width, 500px) * -${startIndex}))`,
    transitionDuration: '.5s'
  }
}
